import { Accordion } from '../../../../../components/general/accordion';
import InsertInvitationIcon from '@mui/icons-material/InsertInvitation';
import { Grid } from '@mui/material';
import FieldText from '../../../../../components/general/fields/fieldText';
import { CasesGeneraValidateProps } from './props';
import { useCasesGeneralValidate } from './hooks';

export const CasesGeneralValidate = ({
    casesGeneral,
}: CasesGeneraValidateProps) => {
    const { formik, getBranchName } = useCasesGeneralValidate(casesGeneral);

    return (
        <Accordion
            title="SECCIÓN DE VALIDACIÓN"
            icon={<InsertInvitationIcon sx={{ color: 'primary.main' }} />}
            defaultExpanded={false}
            mt={0}
        >
            <Grid
                container
                spacing={{ xs: 1.5, md: 1.5 }}
                columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
            >
                <Grid item xs={12} sm={4}>
                    <FieldText
                        label="Documento"
                        name="document"
                        size="small"
                        value={formik.values.document}
                        onChange={console.log}
                    />
                </Grid>
                <Grid item xs={12} sm={4}>
                    <FieldText
                        label="Poliza"
                        name="police"
                        size="small"
                        value={formik.values.policie || ''}
                    />
                </Grid>
                <Grid item xs={12} sm={4}>
                    <FieldText
                        label="Sucursal"
                        name="branch"
                        size="small"
                        value={getBranchName()}
                    />
                </Grid>
            </Grid>
        </Accordion>
    );
};
